import React, { useEffect } from "react";
import "./Createuser.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import UserManagement from "../../../Services/UserManagement/UserManagementService";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import { useState } from "react";
import showToast from "../../../Utils/Toast/ToastNotification";

import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  hideLoader,
  showLoader,
} from "../../../Redux/Slice/Loader/loaderSlice";
import {
  parsePhoneNumberFromString,
  getCountryCallingCode,
  getCountries,
} from "libphonenumber-js";

function getCountryISO(countryCode) {
  return getCountries().find(
    (iso) => getCountryCallingCode(iso) === countryCode.replace("+", "")
  );
}
const Createuser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);
  const inviterId = useSelector(
    (state) => state.auth.user.data?.body?.data?.userData?.id
  );
  const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token)

  const userSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
    phone_number: Yup.string()
      .nullable()
      .test("phone-number", "Invalid phone number", function (value) {
        if (!value || value.trim() === undefined) {
          return true; // Allow empty field
        }

        const { country_code } = this.parent;
        if (!country_code || !value) {
          return this.createError({
            message: `Country code and phone number are required.`,
          });
        }

        const countryISO = getCountryISO(country_code);
        if (!countryISO) {
          return this.createError({
            message: `Invalid country code: ${country_code}`,
          });
        }

        // Clean the phone number by removing all non-numeric characters (except '+')
        const cleanedValue = value.replace(/[^0-9+]/g, "");

        // Ensure the phone number does not already have the country code duplicated
        let formattedNumber;
        if (cleanedValue.startsWith(country_code.replace("+", ""))) {
          // If it already includes the country code, add '+'
          formattedNumber = `+${cleanedValue}`;
        } else {
          // Otherwise, add country code manually
          formattedNumber = `${country_code}${cleanedValue}`;
        }


        // Validate phone number using libphonenumber-js
        const parsedNumber = parsePhoneNumberFromString(formattedNumber);

        if (!parsedNumber || !parsedNumber.isValid()) {
          return this.createError({
            message: `Invalid phone number for ${country_code}`,
          });
        }

        // Extract the correct national number
        const phoneNumberWithoutCountryCode = parsedNumber.nationalNumber;
        // Store cleaned values
        this.parent.phone_number = phoneNumberWithoutCountryCode;
        this.parent.country_code = country_code;

        return true;
      }),
    // country_code: Yup.string().matches(/^\+?\d+$/, "Invalid country code format"),
    role_id: Yup.string().required("Role is required"),
  });

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    country_code: "",
    phone_number: "",
    role_id: "",
    invited_by: inviterId,
  };

  const onSubmit = async (values) => {
    try {
      const response = await UserManagement.addUser(values, token);

      if (response?.data?.statusCode === 200) {
        showToast("success", "User added");
        dispatch(showLoader());
        navigate("/user-listing");
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    const fetchRoles = async () => {
      const response = await UserManagement.getRole(token);
      if (response?.data?.statusCode === 200) {
        setRoles(response?.data?.body?.data?.roles);
      }
    };
    fetchRoles();
  }, []);

  return (
    <>
      <div className="main-inner-block">
        <div className="heading-content">Create New User</div>
        <div className="content">
          <div className="white-box">
            <Formik
              initialValues={initialValues}
              validationSchema={userSchema}
              onSubmit={onSubmit}
            >
              {({ values, handleChange, handleSubmit, errors, touched }) => (
                <Form
                  onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                >
                  <div class="d-flex gap-3 create-user-block w-100 justify-content-between">
                    <div className="row m-0 w-100">
                      <div class="mb-3 col-lg-3 ps-0 padding-right">
                        <label for="firstName" class="form-label">
                          First Name<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="first_name"
                          id="firstName"
                          placeholder="Enter first name"
                          value={values.first_name}
                          onChange={handleChange}
                        />
                        {errors.first_name && touched.first_name && (
                          <div className="error">{errors.first_name}</div>
                        )}
                      </div>

                      <div class="mb-3 col-lg-3 padding-left">
                        <label for="lastName" class="form-label">
                          Last Name<span>*</span>
                        </label>
                        <input
                          type="text"
                          name="last_name"
                          class="form-control"
                          id="lastName"
                          placeholder="Enter last name"
                          value={values.last_name}
                          onChange={handleChange}
                        />
                        {errors.last_name && touched.last_name && (
                          <div className="error">{errors.last_name}</div>
                        )}
                      </div>

                      <div class="mb-3 col-lg-3 padding-left">
                        <label for="email" class="form-label">
                          Email<span>*</span>
                        </label>
                        <input
                          type="email"
                          class="form-control"
                          name="email"
                          id="email"
                          placeholder="Enter email"
                          value={values.email}
                          onChange={handleChange}
                        />
                        {errors.email && touched.email && (
                          <div className="error">{errors.email}</div>
                        )}
                      </div>

                      <div class="mb-3 col-lg-3 pe-0 padding-left">
                        <label for="role" class="form-label">
                          Assign Role
                        </label>
                        <select
                          class="form-select"
                          id="role"
                          name="role_id"
                          value={values.role_id}
                          onChange={handleChange}
                        >
                          <option value="" disabled>Select role</option>
                          {Array.isArray(roles) && roles.length > 0 ? (
                            roles.map((role_id) => (
                              <option key={role_id.id} value={role_id.id}>
                                {role_id.name}
                              </option>
                            ))
                          ) : (
                            <option disabled>No roles available</option>
                          )}
                        </select>
                        {errors.role_id && touched.role_id && (
                          <div className="error">{errors.role_id}</div>
                        )}
                      </div>

                      <div className="mb-3 col-lg-3 ps-0 padding-right">
                        <label className="form-label">Phone Number</label>
                        <ReactPhoneInput
                          country={values.country_code.replace("+", "") || "au"} // Default to 'us' if not available
                          value={values.phone_number}
                          onChange={(value, countryData) => {
                            const dialCode = `+${countryData.dialCode}`;
                            let phoneNumberWithoutCode = value.startsWith(
                              dialCode
                            )
                              ? value.substring(dialCode.length).trim()
                              : value.trim();

                            // Remove any non-numeric characters
                            phoneNumberWithoutCode =
                              phoneNumberWithoutCode.replace(/[^0-9]/g, "");

                            // Update the phone number and country code in form state
                            handleChange({
                              target: {
                                name: "phone_number",
                                value: phoneNumberWithoutCode || "",
                              },
                            });

                            handleChange({
                              target: { name: "country_code", value: dialCode },
                            });
                          }}
                          specialLabel="Phone"
                          enableSearch={true}
                          inputStyle={{
                            width: "100%",
                            height: "38px",
                            fontSize: "14px",
                          }}
                        />

                        {errors.phone_number && touched.phone_number && (
                          <div className="error">{errors.phone_number}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-3 update-div d-flex align-items-center justify-content-center gap-2">
                    <button
                      type="button"
                      class="green-btn submit-btn"
                      onClick={() => navigate("/user-listing")}
                    >
                      Back
                    </button>
                    <button
                      type="submit"
                      class="green-btn submit-btn"
                      onClick={handleSubmit}
                    // style={{ marginLeft: "10px" }}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default Createuser;
